<template>
	<div id="app">
		<el-menu size="mini" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
			@select="handleSelect">
			<div
				style="border-bottom: 1px solid #ccc;display: flex;z-index: 888; flex-direction: row;justify-content: flex-start; width:100%;height: 60px;line-height: 60px;position: fixed;top:0;background-color: white;">
				<img src="./assets/logo.png" style="width: 120px; height: 40px;margin: 10px 0 0 10px;" />
				<div style="margin-left:40px;display: flex; flex-direction: row;justify-content: center; ">
					<el-menu-item index="home">首页</el-menu-item>
					<el-menu-item index="aboutView">关于离离</el-menu-item>
					<el-menu-item index="ProductCenter">产品中心</el-menu-item>
					<el-menu-item index="ProcessinBase">加工基地</el-menu-item>
					<el-menu-item index="SteelknowledgeView">钢材知识</el-menu-item>
					<el-menu-item index="SteelknowledgeSearch">标准查询</el-menu-item>
					<el-menu-item index="liliShop">离离商城</el-menu-item>
					<el-menu-item index="CooperationView">合作意向</el-menu-item>
					<el-menu-item index="PersonalCenter">个人中心</el-menu-item>
				</div>
				<div v-if="displogInfo"
					style="right:320px;position:absolute;color:deepskyblue;font-size: 14px;cursor: pointer;">
					<span @click="showInfo"><i class="el-icon-user-solid"></i>欢迎：{{ user.CUSTNAME }}</span>
				</div>
				<div v-if="!displogInfo" style="right:320px;position:absolute;font-size: 14px;cursor: pointer;">					
					<el-button size="mini" type="success" @click="gopage('loginView')" round>登录</el-button>					
					<el-button size="mini" type="warning" @click="gopage('registerView')" round>注册</el-button>
				</div>
				<div style="float:right;position:absolute; right:10px;">
					<el-input placeholder="关键字查询" v-model="keyword">
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
			</div>
		</el-menu>
		<div style="margin-top: 62px; ">
			<router-view />
		</div>
		<el-drawer :size="size" title="我的信息" @click="doit" :visible.sync="drawer" direction="rtl">
			<div>昵 称:三星</div>
			<div>等 级:三星</div>
			<div>余 额:9867.45</div>
			<div>完成订单:34个</div>
			<div>E-mail:zhaowj@foxmail.com</div>
		</el-drawer>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				size: '300px',
				activeIndex: '1',
				drawer: false,
				displogInfo: false, //显示登录信息
				keyword: '',
				user: {
					
				},
				
			};
		},
		created() {
			this.user=JSON.parse(localStorage.getItem('userInfo'))
			if(this.user.CUSTNAME!='')
				this.displogInfo=true
		},
		methods: {
			handleSelect(key) {
				if (key == 'liliShop') {
					window.location.href = 'https://www.liligc.com/pcshop';
				} else {
					this.$router.push({
						name: key
					}, () => {})
				}
			},
			showInfo() {
				this.drawer = true;
			},
			doit() {
				this.drawer = false;
			},				
			gopage(val){
				this.$router.push({
					name: val
				})
			}
		},
		mounted: function() {},
	};
</script>

<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin: 0;
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
</style>
